import React, { useEffect } from "react";
import { Link } from "react-router-dom";
//
//
import dataCityOrganic from "./dataCityOrganic.json";

import CityOrganicImgMiddle from "./CityOrgImgMiddle";
// images
import LG_Img__organic1 from "../../img_cityOrganic/nave-tata2.jpg";
import LG_Img__organic2 from "../../img_cityOrganic/city-camera3.jpg";
// fade animation related AOS
import Aos from "aos";
import "aos/dist/aos.css";
//
// zoom img in related
import { motion } from "framer-motion";
// 
// 

//

const CityOrganicGrid = ({ setSelectedImgCityOrganic }) => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  //
  //
  const cardImgOrg = dataCityOrganic;
  //
  //
  //
  return (
    <React.Fragment>
      <section id="cityOrganic">
        <div className="cityOrganic___wrapper">
          {/* ------- */}
          {/* HEADER  */}
          {/* ------- */}
          {/* 
          
          
          */}
          <div className="header__Top1">
            {/* heading */}{" "}
            <div className="header__Top1__title">
              <h1 data-aos-duration="1000" data-aos="fade-up">
                ORGANIC CITY
              </h1>
            </div>
            <div className="header__Top1__titleTab">
              <h2> Selected Works:</h2>
              <p> 2016</p>
            </div>
          </div>

          {/* 
          
          
          HEADER Hero
          
          
          
          */}
          {/* ------- */}
          <div className="header__heroImg">
            <div className="header__heroIm_wrapper">
              {/* img hero */}
              <div className="header__heroIm_container">
                <div className="img-box">
                  <img src={LG_Img__organic1} alt="img city mono preview" />
                </div>
              </div>{" "}
            </div>
          </div>

          {/* ---------- */}
          {/*   Descript ROW */}
          <div className="descript__row">
            <div className="descript__row__wrapper">
              <div className="descript__row_heading">
                <h1 data-aos-duration="1000" data-aos="fade-up">
                  PREFACE
                </h1>
                <h2>Below:</h2>
                {/* <h3>The Simurgh Mount </h3> */}

                <p>Art Direction</p>
                <p> Modeling</p>
                <p> Texturing</p>
                <p> Lighting</p>
              </div>
              <div className="descript__row_article">
                <h1>
                  <br />I had previously become acquainted with the paintings of
                  the french artist Yves Tanguy, whose works are often seen
                  depicting futuristic scenes and landscapes. After researching
                  his work in more detail, as I had liked his surrealistic
                  technique and his vision for the future, I finally set eyes on
                  his artwork "Un peut après". <Link to="/Drawings"> </Link>
                  <span className="double-underline">
                    {" "}
                    I immediately realized that his visions and my ideas were
                    mergeable as his frequent use of muted pastel colours and
                    biomorphic shapes in his paintings reminded me of the
                    organic matters and organisms I had seen as a child.{" "}
                  </span>
                  This is why this piece is an integral source of inspiration
                  for this collection, though it is not the only one.
                </h1>
              </div>
            </div>
          </div>
          {/* ------------- */}
          {/* images middle */}
          {/* ------------- */}
          <div id="cityOrganic__imgMiddle">
            <CityOrganicImgMiddle />
          </div>
          {/*  
          
          
          
          */}

          <div className="descript__col">
            <div className="descript__col_container">
              <h1>
                <br />
                "Ever since I can remember, watching
                <span>
                  caterpillars emerge from their cocoons has been a subject of
                  fascination for me.
                </span>
                They made me dream of cities, with towering buildings in all
                sorts of fauna and flora inspired shapes."
              </h1>
              <p>Software used: </p>
              <p> 3ds Studio Max and Photoshop</p>
            </div>
          </div>

          {/* 
          
          
          
          
          
          
          */}
          {/* 
          
          
          
          */}
          <div className="header__heroImg" data-aos="fade-up">
            <div className="header__heroIm_wrapper">
              {/* img hero */}
              <div className="header__heroIm_container">
                <div className="img-box">
                  <motion.img
                    data-aos="fade-up"
                    data-aos-duration="1000"
                    whileHover={{ scale: 1 }}
                    whileTap={{ scale: 0.7 }}
                    src={LG_Img__organic2}
                    alt="img city mono preview"
                  />
                </div>
              </div>{" "}
            </div>
          </div>

          {/*
           */}

          {/* ---------- */}
          {/* descript-top */}
          {/* ---------- */}
          <div className="descript__col">
            <div className="descript__col_container">
              <h1>
                "Man", a wooden sculpture created by the illustrous
                japanese-american artist Isamu Naguchi,{" "}
                <span>
                  became my second source of inspiration, when it made me
                  reflect upon the possible materials I could use to envision my
                  project in my imagination.
                </span>
                Though Naguchi is known for mostly utilizing plaster, stone and
                wood, I decided that my towers would be fashioned out of bones,
                and have working mechanisms like the internal organs of the
                human body.
              </h1>
              <p>
                As you can see from the pictures shown below, I implemented
                these ideas in the form of the sketches, which depict a series
                of biomorphic shapes. These are, aside from my previous mentions
                of the artists Tanguy and Naguchi, inspired by my lifelong
                fascination with insect larvae and cocoons, in particular the
                bioluminescent glow of a Ctenophora (which produces its light
                due to the photoproteins Luciferin and Luciferase).
              </p>

              <Link to="/Process">
                <h2 data-aos="fade-up-right" className="double-underline">
                  <span> See More</span>
                </h2>
              </Link>
            </div>
          </div>

          {/* ---------- */}
          <div className="modal">
            <div className="modal_wrapper">
              <div className="modal_container">
                {/* -------------- */}
                {/* ----MODAL----- */}
                {/* -------------- */}

                <div className="modal__Grid_container">
                  {cardImgOrg &&
                    cardImgOrg
                      .filter(
                        (itemCardOrg) => itemCardOrg.title === "environment"
                      )
                      .map((itemCardOrg) => (
                        <div
                          className="img_LetheCityGallery1_card"
                          key={itemCardOrg.id}
                          onClick={() =>
                            setSelectedImgCityOrganic(itemCardOrg.img1)
                          }
                        >
                          <img src={itemCardOrg.img1} alt={itemCardOrg.alt} />
                        </div>
                      ))}
                </div>
              </div>
            </div>
          </div>

          {/* 
            
            
            
            
            */}
        </div>
      </section>
    </React.Fragment>
  );
};

export default CityOrganicGrid;

